import { InputGroup, Input, Flex, Text, propNames } from "@chakra-ui/react";
import { useState } from "react";

import { TooltipCustom } from "./TooltipCustom";

export const FormInput: React.FC<{
  name: string;
  title: string;
  defaultValue?: string | number;
  type?: string;
  placeholder?: string;
  leftAddon?: any;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  tooltipText?: string;
  maxLength?: number;
  onChange?: (e: any) => void;
}> = (props: {
  name: string;
  title: string;
  defaultValue?: string | number;
  type?: string;
  placeholder?: string;
  leftAddon?: any;
  required?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  maxLength?: number;
  tooltipText?: string;
  onChange?: (e: any) => void;
}) => {
  const { type } = props;
  const [isInvalid, setIsInvalid] = useState(false);

  return (
    <Flex flexDirection={"column"}>
      <Text fontWeight={600} mb="8px" fontSize={"14px"} pt={0}>
        {props.title}
        {props.required ? (
          <Text
            as={"span"}
            fontWeight="700"
            fontSize="14px"
            color="#583CE1"
            ml="3px"
          >
            *
          </Text>
        ) : (
          <></>
        )}
        {props.tooltipText ? (
          <TooltipCustom style={{ ml: "6px" }} label={props.tooltipText} />
        ) : (
          <></>
        )}
      </Text>
      <InputGroup>
        {props.leftAddon}
        <Input
          p={"8px 12px"}
          readOnly={props.readonly}
          disabled={props.disabled}
          required={props.required}
          value={props.defaultValue}
          name={props.name}
          placeholder={props.placeholder}
          // Add custom url validation
          type={props.type === "url" ? undefined : props.type ?? "text"}
          isInvalid={isInvalid}
          onChange={(e) => {
            if (props.onChange) props.onChange(e);
          }}
          maxLength={props.maxLength ?? props.type === "url" ? 2048 : 80}
        />
      </InputGroup>
      {isInvalid ? (
        <Text pt="6px" color="#B91C1C" fontSize="14px">
          {type === "password"
            ? "Password must be at least 15 characters"
            : "Invalid input"}
        </Text>
      ) : (
        <></>
      )}
    </Flex>
  );
};
